export const getInnerContentWidth = function () {
  let size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  switch (size) {
    case 'large':
      return 1200;
    case 'medium':
      return 960;
    case 'small':
      return 720;
    default:
      return 960;
  }
};
export const getInnerContentPadding = breakpoint => {
  switch (breakpoint) {
    case 'xl':
    case 'lg':
    case 'md':
      return 32;
    case 'sm':
    case 'xs':
      return 16;
    default:
      console.error("unimplemented breakpoint ".concat(breakpoint));
      return 32;
  }
};
export const getMainContentPadding = breakpoint => {
  switch (breakpoint) {
    case 'xl':
    case 'lg':
    case 'md':
    case 'sm':
      return 32;
    case 'xs':
      return 16;
    default:
      console.error("unimplemented breakpoint ".concat(breakpoint));
      return 32;
  }
};